import { FC } from 'react';
import { faBadgeCheck } from '~/assets';
import { SceneWrapper } from '~/components';
import { ContentWrapper, Description, IconComponent, Title } from './styles';

const CreditSimulationSuccess: FC = () => {
  return (
    <SceneWrapper>
      <ContentWrapper>
        <IconComponent icon={faBadgeCheck} />
        <Title>Pedido realizado com sucesso.</Title>
        <Description>
          O seu saque foi autorizado e pode ser efetuado.
        </Description>
      </ContentWrapper>
    </SceneWrapper>
  );
};

export default CreditSimulationSuccess;
